<template>
    <section class="contact-list">
        <ContactBox
            v-for="group in groups"
            :key="group.id"
            :name="group.name"
            :groupId="group.id"
            :people="group.people"
            :addContactHandler="addContactHandler"
            :menageGroupPriviligesHandler="menageGroupPriviligesHandler"
            :sendSmsHandler="sendSmsHandler"
            :sendEmailHandler="sendEmailHandler"
            @reloadGroups="(groups) => this.$emit('reloadGroups', groups)"
            @twoFactorChanged="(value) => $emit('twoFactorChanged', value)"
            :isFilter="searchBar.length > 0 && group.people.length < 50"
        />
    </section>
</template>

<script>
import ContactBox from "./ContactBox.vue";

export default {
    name: "ContactList",
    data() {
        return {
            contacts: [],
        };
    },
    props: {
        groups: Array,
        addContactHandler: Function,
        menageGroupPriviligesHandler: Function,
        sendSmsHandler: Function,
        sendEmailHandler: Function,
        searchBar: String,
    },
    components: {
        ContactBox,
    },
};
</script>

<style lang="scss" scoped></style>
